import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Box, Stack, Dialog, InputAdornment } from "@mui/material";
import "./TaskAssignment.css";
import { farmers, region, taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { DialogContent } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { addTaskAssignment, getDataCollectorList, getLocalGovernmentDetails, getRegionList, getStateDetails, getTaskAssignment, updateTaskAssignment } from "../../config/services";
import { useNavigate } from "react-router-dom";
import translations from "../../config/language";
import { Button } from "../../components/Button/button";
import AssignTaskPopup from "./Popup.js/AssignTaskPopup";
import EditTaskAssignPopup from "./Popup.js/EditTaskAssignPopup";
import SearchIcon from "@mui/icons-material/Search";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const TaskAssignment = () => {
  const [assignModal, setAssignModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('page')) || 1;
  });
  const [count, setCount] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [tasks, setTasks] = useState([]);
  const [taskData, setTaskData] = useState({
    taskTitle: "",
    taskDescription: "",
    region: "",
    state: "",
    localGovernment: "",
    dataCollector: "",
    numberOfFarmers: null,
    deadline: null,
    notification: false,
  });

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Task Assignment" && module.is_editor === true
  ) ? true : false;

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    const url = new URL(window.location.href);
    url.searchParams.set('page', value);
    window.history.pushState({}, '', url);
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    setCurrentPage(page);
  }, [window.location.search]);
  const [filterValues, setFilterValues] = useState({
    status: "",
    fromDate: null,
    toDate: null,
  });
  const handleFilterClick = (event) => {
    setFilterModal(true);
  };
  const handleFilterChange = (eventOrValue, fieldName) => {
    if (typeof eventOrValue === "object" && eventOrValue?.target) {
      // This is an event from a Select or regular input
      const { name, value } = eventOrValue.target;
      setFilterValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      // This is a direct value from DatePicker
      if (fieldName === 'fromDate' || fieldName === 'toDate') {
        // Handle null case when date is cleared
        if (!eventOrValue) {
          setFilterValues((prev) => ({
            ...prev,
            [fieldName]: null,
          }));
          return;
        }

        const selectedDate = dayjs(eventOrValue);
        const today = dayjs();

        if (selectedDate.isAfter(today)) {
          if (fieldName === 'fromDate') {
            notifyError(translations[language].fromDateCantBeGreaterThanToday);
          } else {
            notifyError(translations[language].toDateCantBeGreaterThanToday);
          }
          return;
        }

        // Validate fromDate is not after toDate
        if (fieldName === 'fromDate' && filterValues.toDate) {
          if (selectedDate.isAfter(filterValues.toDate)) {
            notifyError(translations[language].fromDateCantBeAfterToDate);
            return;
          }
        }

        // Validate toDate is not before fromDate
        if (fieldName === 'toDate' && filterValues.fromDate) {
          if (selectedDate.isBefore(filterValues.fromDate)) {
            notifyError(translations[language].toDateCantBeBeforeFromDate);
            return;
          }
        }
      }

      setFilterValues((prev) => ({
        ...prev,
        [fieldName]: eventOrValue,
      }));
    }
  };
  const handleClear = () => {
    setFilterValues({
      status: "",
      fromDate: null,
      toDate: null,
    });
    setFilterDataCollector("");
    setIsFilterData(false); // Disable filtering
    fetchTaskAssignment(); // Fetch without filters
  };

  const [regionData, setRegionData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [localGovernmentData, setLocalGovernmentData] = useState([]);
  const [dataCollectorData, setDataCollectorData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(""); // Store selected region
  const [selectedState, setSelectedState] = useState(""); // Store selected state
  const [selectedLocalGov, setSelectedLocalGov] = useState(""); // Store selected Local government
  const [selectedDataCollector, setSelectedDataCollector] = useState(""); // Store selected Data collector
  const [filterDataCollector, setFilterDataCollector] = useState(""); // Store Data collector for filter
  const [isFilteredData, setIsFilterData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [searchText, setSearchText] = useState();
  const [debounceSearchText, setDebouncedSearchText] = useState();
  const language = process.env.REACT_APP_LANGUAGE;

  const fetchData = async () => {
    const region = await getRegionList();

    setRegionData(region.data.payload);

    const dataCollectorData = await getDataCollectorList();
    setDataCollectorData(dataCollectorData.data.results.payload);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const getStateBasedOnRegion = async (regionId) => {
    try {
      const resp = await getStateDetails(regionId);
      if (resp.data.results.success == true) {
        setStateData(resp.data.results.payload);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };
  useEffect(() => {
    if (selectedRegion) {
      getStateBasedOnRegion(selectedRegion);
    }
  }, [selectedRegion]);
  const getLocalGovBasedOnState = async (stateId, regionId) => {
    const data = {
      region_id: regionId,
      state_id: stateId,
    };
    try {
      const resp = await getLocalGovernmentDetails(data);
      if (resp.data.results.success == true) {
        setLocalGovernmentData(resp.data.results.payload);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };
  useEffect(() => {
    if (selectedState && selectedRegion) {
      getLocalGovBasedOnState(selectedState, selectedRegion);
    }
  }, [selectedState, selectedRegion]);
  const handleAddTaskAssignment = async (e) => {
    e.preventDefault();

    const params = {
      deadline_of_task: taskData.deadline
        ? dayjs(taskData.deadline).format("YYYY-MM-DD")
        : null,
      title: taskData.taskTitle,
      description: taskData.taskDescription,
      number_of_farmers: taskData.numberOfFarmers,
      is_notification: taskData.notification,
      region: selectedRegion,
      state: selectedState,
      local_government: selectedLocalGov,
      data_collector: selectedDataCollector.id,
      created_by: "",
    };

    try {
      setLoading(true);
      const resp = await addTaskAssignment(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setAssignModal(false);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        setTaskData({
          taskTitle: "",
          taskDescription: "",
          region: "",
          state: "",
          localGovernment: "",
          dataCollector: "",
          numberOfFarmers: null,
          deadline: null,
          notification: false,
        });
        setSelectedDataCollector("");
        setSelectedRegion("");
        setSelectedState("");
        setSelectedLocalGov("");

        fetchTaskAssignment();
      }
    } catch (error) {
      console.log("error", error.response.data);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      setAssignModal(false);
      setTaskData({
        taskTitle: "",
        taskDescription: "",
        region: "",
        state: "",
        localGovernment: "",
        dataCollector: "",
        numberOfFarmers: null,
        deadline: null,
        notification: false,
      });
      setSelectedDataCollector("");
      setSelectedRegion("");
      setSelectedState("");
      setSelectedLocalGov("");
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]); // Effect runs when searchText changes
  const fetchTaskAssignment = async () => {
    const data = isFilteredData
      ? {
        data_collector__id: filterDataCollector?.id,
        status: filterValues.status,
        start_datetime: filterValues.fromDate
          ? dayjs(filterValues.fromDate).format("YYYY-MM-DD HH:mm:ss")
          : null,
        end_datetime: filterValues.toDate
          ? dayjs(filterValues.toDate).format("YYYY-MM-DD 23:59:59")
          : null,
        search: debounceSearchText,
      }
      : { search: debounceSearchText }; // If not filtered, send an empty object

    try {
      const resp = await getTaskAssignment(data, currentPage, perPage);
      if (resp.data.results.success == true) {
        setTasks(resp.data.results.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
    }
  };
  const handleFilterSubmit = () => {
    setIsFilterData(true);
    setFilterModal(false);
  };
  useEffect(() => {
    fetchTaskAssignment();
  }, [isFilteredData, currentPage, debounceSearchText]);
  const handleClose = (e) => {
    if (e) e.preventDefault();
    setAssignModal(false);
    setSelectedRegion();
    setSelectedState();
    setSelectedDataCollector();
    setSelectedLocalGov();
    setTaskData({
      taskTitle: "",
      taskDescription: "",
      region: "",
      state: "",
      localGovernment: "",
      dataCollector: "",
      numberOfFarmers: null,
      deadline: null,
      notification: false,
    });
  };
  const handleEdit = (task) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setSelectedTask(task);
    setTaskData({
      taskTitle: task.title,
      taskDescription: task.description,
      numberOfFarmers: task.number_of_farmers,
      deadline: dayjs(task.deadline_of_task),
      notification: task.is_notification
    });
    setSelectedRegion(task.region);
    setSelectedState(task.state);
    setSelectedLocalGov(task.local_government);

    const dataCollector = dataCollectorData.find(dc =>
      dc.id === task.data_collector
    );
    setSelectedDataCollector(dataCollector);

    setEditModal(true);
  };
  const handleUpdateTaskAssignment = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    const params = {
      deadline_of_task: taskData.deadline
        ? dayjs(taskData.deadline).format("YYYY-MM-DD")
        : null,
      title: taskData.taskTitle,
      description: taskData.taskDescription,
      number_of_farmers: taskData.numberOfFarmers,
      is_notification: taskData.notification,
      region: selectedRegion,
      state: selectedState,
      local_government: selectedLocalGov,
      data_collector: selectedDataCollector.id
    };

    try {
      setLoading(true);
      const resp = await updateTaskAssignment(selectedTask.id, params);
      if (resp.data.success === true) {
        notifySuccess(resp.data.message);
        setEditModal(false);
        handleClose();
        fetchTaskAssignment();
      }
    } catch (error) {
      notifyError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className="task-assign-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img src={taskAssign.union} alt="" />
            <Typography variant="h6" gutterBottom>
              {translations[language].taskAssignment}
            </Typography>
          </Box>
          <Box className="assign-data-btn">
            <img
              src={taskAssign.filter}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handleFilterClick}
            />
            <button
              className="assign-task-btn"
              onClick={() => setAssignModal(true)}
            >
              {translations[language].taskAssign}
            </button>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "0px 20px",
            boxShadow: "0px 4px 10px rgba(151, 151, 151, 0.12)",
          }}
          className="mt-3 mb-4"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                paddingRight: "0px",
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "400",
                    backgroundColor: "#31A05F",
                    height: "100%",
                    padding: "0px",
                    maxHeight: "unset",
                    padding: "0px 15px",
                  }}
                >
                  <SearchIcon sx={{ color: "#FFFFFF", mr: 1 }} />
                  Search
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="crop-table-container">
          <Table className="task-assign-table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{translations[language].srNo}</TableCell>
                <TableCell> {translations[language].dataCollector}</TableCell>
                <TableCell>{translations[language].description}</TableCell>
                <TableCell>{translations[language].region}</TableCell>
                <TableCell>{translations[language].state}</TableCell>
                <TableCell>{translations[language].localGovernment}</TableCell>
                <TableCell>{translations[language].noOfFarmers}</TableCell>
                <TableCell>{translations[language].deadline}</TableCell>
                <TableCell>{translations[language].statusView}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.length > 0 ? tasks.map((task, index) => {
                return (
                  < TableRow key={index} >
                    <TableCell style={{ textAlign: "center" }}>
                      {index + 1 + (currentPage - 1) * perPage}
                    </TableCell>
                    <TableCell>{task.data_collector_name}</TableCell>
                    <TableCell>{task.description}</TableCell>
                    <TableCell>{task.region_name}</TableCell>
                    <TableCell>{task.state_name ? task.state_name : "-"}</TableCell>
                    <TableCell>{task.local_government_name ? task.local_government_name : "-"} </TableCell>
                    <TableCell>{task.number_of_farmers}</TableCell>
                    <TableCell>
                      {dayjs(task.deadline_of_task).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell style={{ width: "50px" }}>
                      <div className="d-flex gap-4 justify-content-end">
                        <div
                          style={{
                            color: task.status == "7" ? "#31A05F" : "",
                          }}
                        >
                          {task.status == 6
                            ? translations[language].pending
                            : translations[language].completed}
                        </div>
                        <div className="d-flex gap-3">
                          <img
                            src={region.editIcon}
                            alt=""
                            onClick={() => handleEdit(task)}
                            style={{ cursor: "pointer", width: "20px", height: "20px" }}
                          />
                          <VisibilityIcon
                            onClick={() => navigate(`/task-assignment/task-assignment-detail/${task.id}?page=${currentPage}`)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )
              }) : <TableRow>
                <TableCell colSpan={9} style={{ textAlign: "center" }}>
                  <img src={farmers.noData} alt="No Data" />
                </TableCell>
              </TableRow>}
            </TableBody>
          </Table>
        </Box>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          className="pagination"
        >
          <Stack spacing={2} className="mb-3">
            <CustomPagination
              count={Math.ceil(count / perPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </Box>
        {/* Filter Popup */}
        <Dialog
          open={filterModal}
          onClose={() => setFilterModal(false)}
          className="filter-popup"
          maxWidth="xs"
          fullWidth
          disableScrollLock
        >
          <DialogContent style={{ padding: "15px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 0,
                mt: 0,
              }}
            >
              <Typography variant="h6" style={{ marginLeft: "5px" }}>
                {translations[language].filter}
              </Typography>
              <Typography
                onClick={handleClear}
                sx={{ color: "#666", cursor: "pointer" }}
              >
                {translations[language].clear}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <FormControl fullWidth size="mb-3">
                {/* <InputLabel>{translations[language].selectDataCollector}</InputLabel> */}
                {/* <Select
                        label="Select Data Collector"
                        value={filterDataCollector}
                        onChange={(e) => setFilterDataCollector(e.target.value)}
                        IconComponent={ArrowDropDownIcon}
                        className="filter-select"
                        name="dataCollector"
                      >
                        {dataCollectorData.map((item, index) => (
                          <MenuItem value={item.id}>
                            {item.first_name} {item.middle_name} {item.last_name}
                          </MenuItem>
                        ))}
                      </Select> */}
                <Autocomplete
                  name="dataCollector"
                  value={filterDataCollector || null} // Ensure that selectedDataCollector is an object with appropriate properties
                  onChange={(e, newValue) =>
                    setFilterDataCollector(newValue)
                  } // Set the selected value
                  options={dataCollectorData} // Pass options as an array of items
                  getOptionLabel={(option) =>
                    `${option.first_name} ${option.middle_name} ${option.last_name}`
                  } // Format the display label
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={translations[language].selectDataCollector}
                    />
                  )} // Correct way to render input with label
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  } // Ensure proper comparison of option and selected value
                />
              </FormControl>
              <FormControl fullWidth size="mb-3">
                <InputLabel>
                  {translations[language].selectStatus}
                </InputLabel>
                <Select
                  value={filterValues.status}
                  onChange={handleFilterChange}
                  label={translations[language].selectStatus}
                  IconComponent={ArrowDropDownIcon}
                  className="filter-select"
                  name="status"
                >
                  <MenuItem value="" hidden></MenuItem>
                  <MenuItem value={7}>
                    {translations[language].completed}
                  </MenuItem>
                  <MenuItem value={6}>
                    {translations[language].pending}
                  </MenuItem>
                </Select>
              </FormControl>

              <div style={{ display: "flex", gap: "10px" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={translations[language].fromDate}
                    value={filterValues.fromDate}
                    name="fromDate"
                    onChange={(value) => handleFilterChange(value, "fromDate")}
                    disableFuture
                    maxDate={filterValues.toDate}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={translations[language].toDate}
                    value={filterValues.toDate}
                    name="toDate"
                    onChange={(value) =>
                      handleFilterChange(value, "toDate")
                    }
                    disableFuture
                    maxDate={dayjs()} // Prevent future dates
                    minDate={filterValues.fromDate}
                  />
                </LocalizationProvider>
              </div>
              <Button
                title={translations[language].submit}
                onClick={handleFilterSubmit}
                classname={"assign-task-button"}
              />
            </Box>
          </DialogContent>
        </Dialog>
        <AssignTaskPopup
          open={assignModal}
          onClose={handleClose}
          taskData={taskData}
          setTaskData={setTaskData}
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          selectedState={selectedState}
          setSelectedState={setSelectedState}
          selectedLocalGov={selectedLocalGov}
          setSelectedLocalGov={setSelectedLocalGov}
          selectedDataCollector={selectedDataCollector}
          setSelectedDataCollector={setSelectedDataCollector}
          regionData={regionData}
          stateData={stateData}
          localGovernmentData={localGovernmentData}
          dataCollectorData={dataCollectorData}
          handleAddTaskAssignment={handleAddTaskAssignment}
          loading={loading}
          language={language}
        />

        <EditTaskAssignPopup
          open={editModal}
          onClose={() => {
            setEditModal(false);
            handleClose();
          }}
          taskData={taskData}
          setTaskData={setTaskData}
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          selectedState={selectedState}
          setSelectedState={setSelectedState}
          selectedLocalGov={selectedLocalGov}
          setSelectedLocalGov={setSelectedLocalGov}
          selectedDataCollector={selectedDataCollector}
          setSelectedDataCollector={setSelectedDataCollector}
          regionData={regionData}
          stateData={stateData}
          localGovernmentData={localGovernmentData}
          dataCollectorData={dataCollectorData}
          handleUpdateTaskAssignment={handleUpdateTaskAssignment}
          loading={loading}
          language={language}
        />
      </Box >
    </>
  );
};

export default TaskAssignment;